import axios from 'axios';
import eswitchClient from '../configurations/eswitchClient';
import { ManualCalculatorRequest } from '../models/ManualCalculatorRequest';

const useManualCalculator = () => {
    const source = axios.CancelToken.source();
    const calculateBatteryEnergy = (onSuccess: any, requestBody: ManualCalculatorRequest, onError: any) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { status, data } = await eswitchClient.post('/api/calculations/battery-energy', requestBody);
                if (status === 200) {
                    resolve(status);
                    onSuccess({ response: data });
                }
            } catch (error) {
                if (onError) onError(error);
                reject(error);
            }
        });
    };
    const cancelRequests = () => {
        source.cancel();
    };

    return [calculateBatteryEnergy, cancelRequests];
};

export default useManualCalculator;
